

export function generateCode(planSelector, codeSelector) {
  let planInput = document.querySelector(planSelector)
  let planId = planInput.value;

  if (planId === '' || planId === null || planId === undefined)
	return;
  let url = `/subscriptions/paymentdocuments/ajax?handler=GeneratePaymentDocumentCode&planId=${planId}`;
  console.log(url);
  fetch(url)
	.then((response) => {
	  if (!response.ok)
		throw new Error(response);
	  return response.text();
	})
	.then((text) => {
	  let codeInput = document.querySelector(codeSelector);
	  codeInput.value = text;
	})
	.catch((error) => { console.error(error); });
}
